/**
 * Qui peut ouvrir l'éditeur d'un sondage existant.
 *
 * - Sondage d'un compte (creator_id) : ce compte, et lui seul.
 * - Sondage invité : le navigateur qui détient le jeton de propriétaire de
 *   CE sondage (2026-10-02). Deux signaux équivalents : le jeton présent en
 *   local, ou `guest_fingerprint` révélé par get_poll_by_id — la base ne le
 *   révèle qu'à un appelant dont elle a vérifié le jeton.
 *
 * L'empreinte d'appareil locale n'est plus comparée : devinable et instable,
 * elle n'est plus une preuve de possession côté serveur (guest_owns_poll).
 */
export function canOpenPollEditor(input: {
  poll: { creator_id?: string | null; guest_fingerprint?: string | null };
  userId: string | null | undefined;
  hasOwnerToken: boolean;
}): boolean {
  const creatorId =
    input.poll.creator_id && input.poll.creator_id !== "unknown"
      ? input.poll.creator_id
      : null;
  if (creatorId) return !!input.userId && input.userId === creatorId;
  return input.hasOwnerToken || !!input.poll.guest_fingerprint;
}
